import { CustomerSpecificOption } from "./customer-specific-option";

export class SavingAgreementInterestAdjustment {
  documentNumber: string;
  agreementNumber: string;
  date: string;
  interestAmount: number;
  currency: string;
  description: string;
  customerSpecificOptions: CustomerSpecificOption[];
}